import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SelectAllIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M14.478 5.83496L9.46829 10.8447M6.12848 14.1845L2.33325 10.3892"
                stroke={props.stroke ?? '#A7A9AC'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M18 6.01709L9.65046 14.3666L5.85522 10.5714"
                stroke={props.stroke ?? '#A7A9AC'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
